import script from "./FDownloadOrganizationHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FDownloadOrganizationHistory.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__